import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-pin-location-remove",
  "use": "icon-si-glyph-pin-location-remove-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-pin-location-remove\" id=\"icon-si-glyph-pin-location-remove\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>979</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M8.475,0.031 C5.468,0.031 3.032,2.543 3.032,5.64 C3.032,7.224 8.475,15.915 8.475,15.915 C8.475,15.915 13.916,7.306 13.916,5.64 C13.916,2.543 11.479,0.031 8.475,0.031 L8.475,0.031 Z M11.031,6.016 L5.969,6.016 L5.969,4.954 L11.031,4.954 L11.031,6.016 L11.031,6.016 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-pin-location-remove.svg
// module id = 2spi
// module chunks = 62